import React from "react";

const EditorNumber = (props) => {
 
    return (
        <div className={(props.className && props.className) + " lottoNumber " + (props.selected ? "selected" : "")} onClick={(evt) => {props.onClickNumber && props.onClickNumber(props.number)}}>
            {props.number}
        </div>
    );
};
export default EditorNumber;